import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/app/store';
import { BotTypeEnum } from '@/utils/BotTypeEnum';

interface createBotFlow {
  currentStep: number;
  data: Record<string, any>;
  type: string;
  ui: {
    showModal: boolean;
    section?: string;
  };
}

const initialState: createBotFlow = {
  currentStep: 0,
  data: {},
  type: '',
  ui: {
    showModal: false,
    section: '',
  },
};

const createBotFlowSlice = createSlice({
  name: 'createBotFlow',
  initialState: initialState,
  reducers: {
    setType(state, action: PayloadAction<string>) {
      state.type = action.payload;
    },
    setStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setSection(state, action: PayloadAction<string>) {
      state.ui.section = action.payload;
    },
    updateData(state, action: PayloadAction<any>) {
      state.data = { ...state.data, ...action.payload };
    },
    toggeleCreateModal(state, action: PayloadAction<boolean>) {
      state.ui.showModal = action.payload;
    },
    startVersionCreation(state, action: PayloadAction<any>) {
      state.data = action.payload;
      state.type = BotTypeEnum.MARKETPLACE;
      state.currentStep = 1;
      state.ui.showModal = true;
    },
    resetCreateFlow(state) {
      state.currentStep = 0;
      state.data = {};
      state.type = '';
      state.ui.showModal = false;
      state.ui.section = '';
    },
  },
});

export const { resetCreateFlow, updateData, setStep, setType, toggeleCreateModal, startVersionCreation, setSection } = createBotFlowSlice.actions;
export default createBotFlowSlice.reducer;

export const selectCreateModalState = (state: RootState) => state.createBotFlow.ui.showModal;

export const selectCurrentTypeState = (state: RootState) => state.createBotFlow.type;

export const selectCurrentDataState = (state: RootState) => state.createBotFlow.data;

export const selectCurrentStepState = (state: RootState) => state.createBotFlow.currentStep;

export const selectCurrentSectionState = (state: RootState) => state.createBotFlow.ui.section;
